module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-bar"
  }, [_c('a', {
    staticClass: "return-btn",
    on: {
      "click": _vm.goBack
    }
  }, [_c('i', {
    staticClass: "icon-return"
  }), _vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b13be4d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header-return.vue
// module id = 170
// module chunks = 1